// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'opportunity';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinejoin='round'
    d='M12.168 12.024 9 17.496l-3.168-5.472m6.336 0H5.832m6.336 0L14.76 7.56m-8.928 4.464L3.24 7.56m.072-.072L.576 2.808h16.92l-2.736 4.68H3.24'
  />
);

export const viewBox = '0 0 18 18';
